var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 384 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M384 56c0 13.25-10.75 24-24 24h-67.98l-146.9 352H232c13.25 0 24 10.75 24 24s-10.7 24-24 24H24c-13.25 0-24-10.7-24-24s10.75-24 24-24h70.6L241.5 80H152c-13.2 0-24-10.75-24-24s10.8-24 24-24h208c13.3 0 24 10.75 24 24z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }